import _ from "lodash";
import React, { PureComponent } from "react";
import classes from "./TagUnit.scss";
import ScreenPanel from "../../ScreenPanel";
import { connect } from "react-redux";
import { graphql, compose } from "lib/apolloClient";
import I18nHOC from "UIComponents/I18nHOC";
import { getCourseUnitQuery } from "Post/modules/PostQuery";
import { updatePost } from "Post/modules/PostModule";
import { getFieldUids } from "modules/TaggableElementsUtils";
import { getCourseDetailsFromCache } from "Course/modules/CourseGraphqlHelpers";
import moment from "moment";
import UnitList from "./UnitList";
import { Button, SearchInput } from "@toddle-edu/ds-web";
import { getCourseUnitFromCache } from "AppComponents/Post/modules/PostGraphqlHelpers";
import { getUserInfo } from "Login/modules/LoginModule/LoginUtils";
import { getSelectedAcademicYearId } from "modules/CommonSelectors";

const FooterComponent = React.memo(props => {
  const { t, onBackClick } = props;

  return (
    <div className={classes.footerButtonContainer}>
      <Button
        size={"large"}
        onClick={onBackClick}
        variant="outlined-subtle"
        style={{ marginRight: "12px" }}
      >
        {t("common:previous")}
      </Button>
    </div>
  );
});

FooterComponent.displayName = "FooterComponent";

class TagUnit extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      selectedUnitId: props.unitPlanId,
      showDoneButton: false,
      selectFromAllPYP: props.unitPlanId ? false : props.selectFromAllPYP,
    };
  }

  onNextClick = () => {
    const {
      screenPanelProps: { goToNextScreen },
    } = this.props;
    goToNextScreen();
  };

  onDoneClicked = () => {
    const { updatePost, screenPanelProps } = this.props;
    updatePost({
      unitPlan: null,
      isResourceSkipped: false,
      resourceId: null,
      resourceType: null,
      resourceItem: undefined,
      elementPYP: undefined,
    });
    screenPanelProps.onCloseClick();
  };

  onNextClicked = () => {
    const {
      state: { selectedUnitId, selectFromAllPYP },
      props: {
        unitPlanId: propUnitPlanId,
        screenPanelProps: { goToNextScreen, goToFinalScreen },
        unitPlans,
        originalUnitPlan,
        originalElementPYP,
      },
    } = this;

    if (selectFromAllPYP) {
      const updatePostParams = {
        selectFromAllPYP,
        unitPlan: null,
        resourceId: null,
        resourceType: null,
        resourceItem: undefined,
      };
      if (_.isEmpty(propUnitPlanId)) this.props.updatePost(updatePostParams);
      else
        this.props.updatePost({
          ...updatePostParams,
          elementPYP: null,
        });
      goToFinalScreen();
      return;
    }
    const selectedUnitPlan = _.find(
      unitPlans,
      item => item.id == selectedUnitId
    );

    if (!_.isEmpty(propUnitPlanId) && propUnitPlanId == selectedUnitId) {
      this.props.updatePost({
        unitPlan: selectedUnitPlan,
      });
    } else {
      this.props.updatePost({
        isResourceSkipped: false,
        resourceId: null,
        resourceType: null,
        resourceItem: undefined,
        elementPYP: _.isEqual(
          _.get(selectedUnitPlan, "id", null),
          _.get(originalUnitPlan, "id", undefined)
        )
          ? originalElementPYP
          : undefined,
        unitPlan: selectedUnitPlan,
      });
    }
    goToNextScreen();
  };

  onUnitClicked = unit => {
    const { selectedUnitId } = this.state;
    this.setState({
      selectedUnitId: unit.id,
      showDoneButton: !_.isEmpty(this.props.unitPlanId),
      selectFromAllPYP: false,
    });
    setTimeout(() => this.onNextClicked());
  };

  onSelectFromAllPYP = () => {
    const {
      state: { selectFromAllPYP },
    } = this;

    this.setState({
      selectFromAllPYP: !selectFromAllPYP,
      selectedUnitId: null,
    });
  };

  render() {
    const {
      props: {
        screenPanelProps,
        unitPlans,
        isLoading,
        isData,
        t,
        curriculumProgramType,
        searchText,
        updateSearchText,
      },
      state: { selectedUnitId, showDoneButton, selectFromAllPYP },
    } = this;

    const modalHeaderTitle = screenPanelProps.modalHeaderTitle;

    return (
      <ScreenPanel
        {...screenPanelProps}
        modalHeaderTitle={modalHeaderTitle}
        footerComponent={
          <FooterComponent
            t={t}
            onNextClicked={this.onNextClicked}
            selectedUnitId={selectedUnitId}
            selectFromAllPYP={selectFromAllPYP}
            showDoneButton={showDoneButton}
            onDoneClicked={this.onDoneClicked}
            onBackClick={
              !_.isUndefined(screenPanelProps?.goToPreviousScreen) &&
              screenPanelProps?.goToPreviousScreen
            }
          />
        }
        titleTextStyle={{ fontSize: "1.8rem", alignItems: "center" }}
        titleContainerStyle={{ marginTop: "32px" }}
        containerStyle={{ padding: "0 32px" }}
        footerContainerStyle={{ padding: "0px" }}
        showNewFooter={true}
        showNewDesign={true}
        showCustomHeaderIcon={false}
      >
        <div className={classes.container}>
          <SearchInput
            placeholder={t("common:search_unit_plan")}
            value={searchText}
            onChange={updateSearchText}
            size={"large"}
            testId={"journal-postcreation-tagunit"}
          />
          <UnitList
            selectedUnitId={selectedUnitId}
            selectFromAllPYP={selectFromAllPYP}
            searchText={searchText}
            unitPlans={unitPlans}
            onItemClicked={this.onUnitClicked}
            isData={isData}
            isLoading={isLoading}
            showLoaderBar={false}
            onSelectFromAllPYP={this.onSelectFromAllPYP}
            curriculumProgramType={curriculumProgramType}
          />
        </div>
      </ScreenPanel>
    );
  }
}

const mapActionCreators = {
  updatePost,
};

const mapStateToProps = (state, ownProps) => {
  // const organizationId = state.login.userInfo.org_id;
  const userInfo = getUserInfo();
  const courseIdFromParent = _.get(
    ownProps,
    "screenPanelProps.postDetails.courseId"
  );
  const courseId = courseIdFromParent
    ? courseIdFromParent
    : state.teacher.selected_class.selected_course;
  const curriculumProgramType = _.get(
    state,
    "platform.currentCurriculumProgram.type",
    ""
  );
  const {
    unitPlan = {},
    selectFromAllPYP,
    elementPYP = [],
    originalUnitPlan = {},
    originalElementPYP = [],
  } = state.post.postDetails;

  let selectFromAllPYPNew = selectFromAllPYP;
  if (!selectFromAllPYP && !_.isEmpty(elementPYP) && _.isEmpty(unitPlan))
    selectFromAllPYPNew = true;

  const academicYearId = getSelectedAcademicYearId(state);
  const courseGradeFilters = {
    academicYearId,
  };

  const courseDetails = getCourseDetailsFromCache({
    id: courseId,
    courseGradeFilters,
  });
  const currentAcademicYear = _.get(courseDetails, "academicYear", null);
  const startDate = moment(_.get(currentAcademicYear, "startDate", "")).format(
    "YYYY-MM-DD"
  );
  const endDate = moment(_.get(currentAcademicYear, "endDate", "")).format(
    "YYYY-MM-DD"
  );
  const userType = userInfo.user_type;
  const uids = getFieldUids({ curriculumProgramType });
  return {
    endDate,
    startDate,
    mode: state.post.postCreationMode,
    unitPlanId: _.get(unitPlan, "id", null),
    templateId: _.get(unitPlan, "templateId", ""),
    courseId,
    unitPlan,
    originalUnitPlan,
    elementPYP,
    originalElementPYP,
    selectFromAllPYP: selectFromAllPYPNew,
    curriculumProgramType,
    userId: userInfo.id,
    userType,
    t: ownProps.t,
    filters: {
      searchText: _.get(ownProps, "searchText", ""),
      isShowPrivate: true,
      showAllPublishedUnits: userType === "student",
    },
    uids,
  };
};

const TagUnitWithHOC = compose(
  connect(mapStateToProps, mapActionCreators),
  graphql(getCourseUnitQuery, {
    name: "getCourseUnit",
    options: ({ courseId, filters, uids }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        filters: filters,
        id: courseId,
        groupBy: "UNIT_TYPE",
        uids,
      },
    }),
    props({ getCourseUnit, ownProps: { unitPlan, courseId, filters, uids } }) {
      const courseDetail = getCourseUnitFromCache({
        filters: filters,
        id: courseId,
        groupBy: "UNIT_TYPE",
        uids,
      });
      let unitPlans = [];
      _.forEach(_.get(courseDetail, "unitPlans.edges", []), item => {
        if (!_.isEmpty(item.node)) {
          unitPlans = [
            ...(unitPlans || []),
            ...(_.get(item, "node", []) || []),
          ];
        }
      });

      return {
        unitPlans: !_.isEmpty(unitPlan)
          ? _.uniqBy([unitPlan, ...unitPlans], "id")
          : unitPlans,
        isData: !_.isEmpty(courseDetail),
        isLoading:
          getCourseUnit["networkStatus"] == 1 ||
          getCourseUnit["networkStatus"] == 2,
      };
    },
  })
)(TagUnit);

class TagUnitWrapper extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      searchText: "",
    };
  }

  updateSearchText = value => {
    this.setState({ searchText: value });
  };

  render() {
    return (
      <TagUnitWithHOC
        {...this.props}
        searchText={this.state.searchText}
        updateSearchText={this.updateSearchText}
      />
    );
  }
}

export default compose(I18nHOC({ resource: ["common", "journal"] }))(
  TagUnitWrapper
);
